import axios from 'axios'

const ApiMiIndicador = axios.create({
  baseURL: process.env.VUE_APP_API_MI_INDICADOR_HOST,
})

const getCache = key => {
  const data = localStorage.getItem(key)
  if (!data) return null

  const { value, expiry } = JSON.parse(data)
  if (Date.now() > expiry) {
    localStorage.removeItem(key)
    return null
  }
  return value
}

const setCache = (key, value, ttl) => {
  const expiry = Date.now() + ttl
  localStorage.setItem(key, JSON.stringify({ value, expiry }))
}

// Tiempo de vida de la caché en milisegundos (30 minutos)
const cacheTTL = 30 * 60 * 1000

ApiMiIndicador.interceptors.request.use(config => {
  const cachedResponse = getCache(config.url)
  if (cachedResponse) {
    config.adapter = () => {
      return Promise.resolve({
        data: cachedResponse,
        status: 200,
        statusText: 'OK',
        headers: config.headers,
        config,
        request: config,
      })
    }
  }
  return config
})

ApiMiIndicador.interceptors.response.use(response => {
  setCache(response.config.url, response.data, cacheTTL)
  return response
})

export default ApiMiIndicador
